var _path, _path2, _g, _path3, _g2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAppGoogleplay = function SvgAppGoogleplay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.39584 1.44666C2.15834 1.69626 2 2.02832 2 2.41867V21.5807C2 21.971 2.15724 22.3042 2.39584 22.5527L12.8757 12.0002L2.39694 1.44666H2.39584Z",
    fill: "#00CCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_243_4027",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 15,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39703 1.00009H16.5792V12.0001H2.39703V1.00009Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_243_4027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5792 8.27122L4.15413 1.19005C3.53948 0.840393 2.82806 1.00093 2.39703 1.44735L12.8758 11.9998L16.5792 8.27232V8.27122Z",
    fill: "#00F270"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_243_4027",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 12,
    width: 15,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.39703 12.0001H16.5781V23.0001H2.39703V12.0001Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_243_4027)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15511 22.8087L16.5779 15.7276L12.8768 12.0001L2.39801 22.5525C2.82794 22.999 3.53825 23.1595 4.15401 22.8087",
    fill: "#FA3142"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9662 10.7719L16.579 8.27151L12.8768 11.999L16.579 15.7265L20.9662 13.2272C21.4445 12.9545 21.6842 12.4773 21.6842 12.0001C21.6842 11.5218 21.4445 11.0446 20.9662 10.7719Z",
    fill: "#FFD200"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAppGoogleplay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "app-googleplay.1af9047284eb62accc5117e23a0268dd.svg";